import { useRoute, RouteProp, StackActions } from '../../navigation/native';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from '../../components/styled';
import { useNavigation } from '../../navigation/native';

import {
  shiftLogActions,
  selectShiftLogError,
  selectCurrentSiteCode,
  selectCurrentAsset,
  selectIsShiftLogsLoading,
  selectPath,
  selectUser,
  selectTemplateSelected,
} from '../../store';
import {
  NavBar,
  NavTextButton,
  LogCreationDetails,
  FabButton,
  LoadingOverlay,
} from '../../components';
// TODO: remove this
import {
  GetShiftLogsActionAsync,
  GetTeamShiftLogsActionAsync,
} from '../../../Action/ShiftLogAction';
import { RootStackParamList } from '../../app/Navigation';
import TemplatesModal from './TemplatesModal';
import AssetPicker from './AssetPicker';
import { Route } from '../../app/Route';
import { AppDispatch } from '../../store/store';
import { displayInformationAlert } from '../../helpers/Functions';

const CreateShiftLogScreen = () => {
  const dispatch = useDispatch<AppDispatch>();
  const route = useRoute<RouteProp<RootStackParamList, 'CreateShiftLogScreen'>>();
  const navigation = useNavigation();

  const siteCode = selectCurrentSiteCode.useHook();
  const selectedAsset = selectCurrentAsset.useHook();
  const user = selectUser.useHook();
  const assetPath = selectPath.useHook();
  const isLoading = selectIsShiftLogsLoading.useHook();
  const errorMessage = selectShiftLogError.useHook();
  const selected = selectTemplateSelected.useHook();

  const isTeamLog = route.params?.isTeamLog;

  useEffect(() => {
    dispatch(shiftLogActions.resetCreateShiftLog());
  }, [dispatch]);

  useEffect(() => {
    if (selectedAsset) {
      dispatch(
        shiftLogActions.getShiftLogTemplates({
          siteCode: siteCode,
          assetName: selectedAsset.assetName,
        }),
      );
    }
  }, [dispatch, selectedAsset, siteCode]);
  useEffect(() => {
    if (errorMessage)
      displayInformationAlert({
        title: 'Error',
        description: errorMessage,
        onOk: () => dispatch(shiftLogActions.resetErrorMessage()),
      });
  }, [dispatch, errorMessage]);

  const handleCreateLogPressed = () => {
    dispatch(
      shiftLogActions.createShiftLog({
        siteCode: siteCode,
        assetName: selectedAsset.assetName,
        templateId: selected.templateName,
      }),
    )
      .unwrap()
      .then(() => {
        const params = {
          siteCode: siteCode,
          assetName: selectedAsset.assetName,
        };

        dispatch(
          isTeamLog ? GetTeamShiftLogsActionAsync(params) : GetShiftLogsActionAsync(params),
        ).then(() => {
          navigation.dispatch(
            StackActions.replace(Route.editShiftLogScreen, {
              isTeamLog,
            }),
          );
        });
      })
      .catch(() => {});
  };

  const handleCancelPressed = () => {
    navigation.goBack();
  };

  return (
    <>
      <NavBar
        title="Create New Log"
        leftButton={<NavTextButton text="Cancel" onPress={handleCancelPressed} />}
      />

      <SafeAreaView>
        <LogCreationDetails name={user.name} date={new Date()} assetPath={assetPath} />

        <AssetPicker />

        <FabButton
          label="Create Log"
          onPress={handleCreateLogPressed}
          icon="check"
          disabled={typeof selected === 'undefined'}
        />
      </SafeAreaView>

      <LoadingOverlay visible={isLoading} />
      <TemplatesModal />
    </>
  );
};

export default CreateShiftLogScreen;

const SafeAreaView = styled.SafeAreaView`
  flex: 1;
  background-color: #f3f7fa;
`;
